import React, { useEffect } from 'react'
import { Stack } from 'expo-router'
import { useStore } from '@/router/(root)/cth/cthModule'

export default function CthLayout() {

  const setPlayedDate = useStore(s => s.setPlayedDate)

  useEffect(() => {
    setPlayedDate()
  }, [])

  return (
    <Stack screenOptions={{ headerShown: false }} />
  )
}
